import Chart from "chart.js";
import InfoIcon from "@material-ui/icons/Info";
import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Timeline from "@material-ui/icons/Timeline";
import Tooltip from "@material-ui/core/Tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import { compact, forEach, keys, map, sortBy } from "lodash";
import { fulfillWith } from "./utils";

import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { localeString } from "services/utils";

import lightTooltipStyle from "assets/EnergyCompany/jss/lightTooltip";

const styles = theme => ({
  ...lightTooltipStyle(theme),
  tooltipWrapper: {
    ...lightTooltipStyle(theme).tooltipContentWrapper,
    alignItems: "flex-end",
  },
});

class RiscoChart extends Component {
  componentDidMount() {
    this.handleChart();
  }

  componentDidUpdate() {
    this.handleChart();
  }

  getSortedMonths() {
    return sortBy(keys(this.props.data), month => moment(month).unix());
  }

  getLabels() {
    const labels = map(this.getSortedMonths(), label => moment(label).format("MMM Y"));
    return fulfillWith(labels, "");
  }

  getData(key) {
    let data = [];
    forEach(this.getSortedMonths(), month => {
      data.push(this.props.data[month][key]);
    });
    return fulfillWith(data, undefined);
  }

  handleChart() {
    const ctx = "chart-risco";
    const labels = this.getLabels();
    const energiaVendida = this.getData("energiaVendida");
    const margemSeguranca = this.getData("margemSeguranca");

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: compact([{
          backgroundColor: 'rgba(54, 162, 235, 0.4)',
          borderColor: 'rgba(54, 162, 235, 1)',
          data: margemSeguranca,
          fill: false,
          label: 'Margem de Segurança (12 meses)',
          type: 'line',
          yAxisID: 'margemSeguranca',
        }, {
          backgroundColor: 'rgba(255, 99, 132, 0.4)',
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 1,
          data: energiaVendida,
          label: 'MW médio negociado',
          yAxisID: 'mwMedNegociado',
        }]),
        labels,
      },
      options: {
        scales: {
          yAxes: [
            {
              id: 'margemSeguranca',
              position: 'left',
              ticks: {
                beginAtZero: true,
                callback: value => `${localeString(value)} R$/MWh`,
              },
            }, {
              gridLines: {
                display: false,
              },
              id: 'mwMedNegociado',
              position: 'right',
              ticks: {
                beginAtZero: true,
                callback: value => `${localeString(value)} MWmed`,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (tooltipItem.datasetIndex + 1 < data.datasets.length) {
                return `${localeString(tooltipItem.yLabel)} R$/MWh`;
              } else {
                return `${localeString(tooltipItem.yLabel)} MWmed`;
              }
            },
          },
          intersect: false,
          mode: 'index',
        },
      },
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={<canvas id="chart-risco" />}
            icon={<Timeline />}
            title={
              <Tooltip
                classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
                placement="top"
                title="Margem de Risco = (Capital Social) x Idade / (MWméd x 8760)"
              >
                <span className={classes.tooltipWrapper}>
                  Margem de Risco <InfoIcon />
                </span>
              </Tooltip>
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
};

RiscoChart.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default withStyles(styles)(RiscoChart);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/RiscoChart.jsx